<template>
  <section>
    <div class="row">
      <div class="col">
        <p>
          Check those Skills (Service Category) to associate this technician with. If the technician
          is on Commission, supply a percentage for each skill.
        </p>
        <p>To configure Service Categories, go to Checklists > Service</p>
      </div>
    </div>
    <div class="row">
      <div class="col custom-list-wrapper">
        <ul class="custom-list">
          <li v-for="item of selected" :key="item.id">
            <div class="row">
              <div class="col">
                <input
                  type="checkbox"
                  v-model="item.checked"
                  class="custom-checkbox"
                  @click="changed"
                />
                <span class="ml-2">{{ item.name }}</span>
              </div>
              <div class="col">
                <input
                  type="number"
                  v-model="item.commission"
                  class="custom-commission"
                  title="commission %"
                />
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'user-skills',
  data() {
    return {
      selected: []
    }
  },
  mounted() {
    this.init()
  },
  computed: {
    ...mapGetters('lookups', ['lookups']),
    ...mapGetters('users', ['user']),
    skills() {
      let _data = []
      if (this.user) {
        if (this.user.skillDetail) {
          _data = this.user.skillDetail
        }
      }
      return _data
    }
  },
  methods: {
    init() {
      this.selected = []
      if (this.lookups['CalibrateServiceGroup']) {
        this.lookups['CalibrateServiceGroup'].forEach(element => {
          this.selected.push({
            id: element.id,
            name: element.name,
            checked: false,
            commission: 0
          })
        })
        if (this.selected.length > 0) {
          this.selected.forEach(element => {
            let found = this.skills.find(
              x => parseInt(x.calibrateServiceGroup) === parseInt(element.id)
            )
            if (found) {
              element.checked = true
              element.commission = found.commission ? parseFloat(found.commission).toFixed(1) : 0
            }
          })
        }
      }
    },
    changed() {
      this.$emit('changed')
    },
    getSkills() {
      let data = []
      console.log('Getting Skills', this.selected)
      this.selected.forEach(element => {
        if (element.checked) {
          data.push({
            technicianServiceGroup: null,
            calibrateServiceGroup: parseInt(element.id),
            commission:
              element.commission !== null && element.commission !== undefined
                ? parseFloat(element.commission)
                : 0
          })
        }
      })
      console.log('Got Skills', data)
      return data
      // let skills = ''
      // this.selected.forEach(element => {
      //   if (element.checked) {
      //     if (skills !== '') {
      //       skills += ','
      //     }
      //     skills += element.id
      //   }
      // })
      // return skills
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-list-wrapper {
  overflow-x: hidden;
  overflow-y: auto;
  max-height: 300px;
}
.custom-list {
  list-style: none;
  li {
    margin-bottom: 8px;
  }
}
.custom-commission {
  width: 80px;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/components/users/forms/user-skills.vue